module.exports = __webpack_public_path__ + "static/gary-mcmillan-45981788e5934fa9a78fd29f8f35c2fa.png";